import AppLogo from "./components/appLogo/AppLogo";
import styles from "./AppHeader.module.less";
import HeaderMenu from "./components/headerMenu/HeaderMenu";
import { VersionUpdater } from "~/components/versionUpdater/VersionUpdater";

function AppHeader() {
  return (
    <div className={styles.AppHeader}>
      <div className={styles.wrapper}>
        <VersionUpdater />
        <AppLogo />
        <HeaderMenu />
      </div>
    </div>
  );
}

export default AppHeader;
